module.exports = __webpack_public_path__ + "img/⁫ico-pages.e9f17c0b.svg";